import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {getLevels} from '../../../actions/levels';
import updateLevel from '../../../actions/update-level';
import {getCustomerNumbers} from '../../../actions/outlet';
import UpdateLevelPage from './update-level-page';

class UpdateLevel extends Component {
  state = {
    selectedOutletId: null
  };
  handleSubmit = (payLoad) => {
    const {dispatch} = this.props;

    dispatch(actions.submitFields('deep.admin_update_level', updateLevel(payLoad, this.backLinkUrl())))
      .then(() => {
        this.setState({
          selectedOutletId: null
        });
        this.id = null;
      });
  };
  handleSelectChange = (change) => {
    this.setState({
      selectedOutletId: change ? change.value : null
    });
  };

  handleSelectInputChange = (inputValue) => {
    if (inputValue !== '') {
      const {dispatch} = this.props;
      dispatch(getCustomerNumbers(inputValue, '', true, true));
    }
    return inputValue;
  };

  UNSAFE_componentWillMount() {
    const {dispatch, match} = this.props;
    this.id = +match.params.id;
    if (this.id) {
      this.setState({
        selectedOutletId: this.id
      });
    }
    dispatch(actions.reset('deep.admin_update_level'));
    dispatch(getLevels(true));
    dispatch(getCustomerNumbers('', '', true, true));
  }

  backLinkUrl() {
    return this.id ? '/admin/outlets' : '/admin/levels';
  }

  selectedOutlet() {
    const {outletCustomerNumbers} = this.props;
    return outletCustomerNumbers.find(o => `${o.id}` === `${this.state.selectedOutletId}`);
  }

  outletValue() {
    const outlet = this.selectedOutlet();
    return {
      value: outlet ? outlet.id : '',
      label: outlet ? `${outlet.attributes['customer-number']} - ` +
        `${(outlet.attributes.level == null) ? 'Without Level' : outlet.attributes.level}` : ''
    };
  }

  outletValues() {
    const {outletCustomerNumbers} = this.props;
    return outletCustomerNumbers.map(v => ({
      value: v.id,
      label: `${v.attributes['customer-number']} - ` +
      `${(v.attributes.level == null) ? 'Without Level' : v.attributes.level}`
    }));
  }

  levelValues() {
    const {levels} = this.props;
    const outlet = this.selectedOutlet();
    return levels.filter(l => !(outlet && (`${outlet.attributes['override-level-id']}` === `${l.id}` ||
      (outlet.attributes['override-level-id'] === null && l.attributes.name === outlet.attributes.level))))
      .map(level => ({
        value: level.id,
        label: level.attributes.name
      }));
  }

  updateButtonDisabled() {
    const {formValid} = this.props;
    return !formValid || !this.selectedOutlet();
  }

  render() {
    const {levelsFetched} = this.props;

    return (
      levelsFetched && (
        <UpdateLevelPage
          backLinkUrl={this.backLinkUrl()}
          handleSelectChange={this.handleSelectChange}
          handleSelectInputChange={this.handleSelectInputChange}
          handleSubmit={this.handleSubmit}
          levelValues={this.levelValues()}
          outletValue={this.outletValue()}
          outletValues={this.outletValues()}
          updateButtonDisabled={this.updateButtonDisabled()}
        />
      ));
  }
}

const mapStateToProps = state => ({
  levels: state.level.levels,
  levelsFetched: state.level.fetched,
  outletCustomerNumbers: state.customer_numbers.outlets,
  outletCustomerNumbersFetched: state.customer_numbers.fetched,
  formValid: state.deep.forms.admin_update_level.$form.valid,
});

export default connect(mapStateToProps)(UpdateLevel);
